/* eslint-disable no-alert */
import {Button, Card, Layout, Text} from '@ui-kitten/components';
import React from 'react';
import {Linking, StyleSheet} from 'react-native';
// import {youtubeIcon} from '../../../../assets/images';
import themeColors from '../../../../assets/json/custom-theme.json';
import {px} from '../../../../utils';
import {renderIf} from '../../../../utils/Utils';

const CustomCard = ({data}) => {
  const {description, url, title} = data;

  const handleOpenLink = async (urlLink) => {
    const supported = await Linking.canOpenURL(urlLink);

    if (supported) {
      await Linking.openURL(urlLink);
    } else {
      alert(`Don't know how to open this URL: ${urlLink}`);
    }
  };

  return (
    <Card style={styles.container}>
      <Layout style={styles.body}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.description}>{description}</Text>

        {renderIf(
          url,
          <Button
            style={{marginTop: px(15)}}
            onPress={() => handleOpenLink(url)}>
            Watch video
          </Button>,
        )}
      </Layout>
    </Card>
  );
};

const styles = StyleSheet.create({
  container: {
    borderColor: themeColors['color-primary-400'],
    borderWidth: 2,
    width: '100%',
    marginBottom: px(17),
  },
  body: {
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    marginBottom: px(15),
    paddingHorizontal: px(15),
  },
  imageContainer: {
    position: 'relative',
    width: px(80),
    height: px(80),
  },
  image: {
    width: px(80),
    height: px(80),
    backgroundColor: 'black',
    justifyContent: 'center',
  },
  title: {
    fontSize: px(16),
    fontWeight: '700',
    marginTop: px(15),
  },
  description: {
    fontSize: px(16),
    marginTop: 2,
  },
});

export default CustomCard;
